import React, { useMemo, useState } from "react";
import { ApplicationDeadline } from "./ApplicationDeadline";
import { getDevice } from "../utils/deviceDetector";
import { FaGear } from "react-icons/fa6";
import { useAuth } from "../AuthContext";
import { handleGiveReviewAccess } from "../utils/firebaseUtils";
import Modal from "./Modal";
import "../userHeader.css";

const UserHeader = () => {
  const deviceType = useMemo(() => getDevice(), []); // Compute once and cache

  // modal stuff
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setEmail("");
    setSelectedRole("reviewer");
    setMessage(null);
    setIsModalOpen(false);
  };
  const { profile } = useAuth();
  const [email, setEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("reviewer");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const getNameOrEmail = () => {
    const value = profile?.firstName || profile?.email;
    return value
      ? value.length > 10
        ? `${value.substring(0, 10)}...`
        : value
      : "";
  };

  const giveReviewAccess = async () => {
    if (!email) {
      setMessage("Please enter an email address.");
      return;
    }
    if (!email.includes("@")) {
      setMessage("Please enter a valid email address.");
      return;
    }
    if (email === profile?.email) {
      setMessage("You cannot modify your own access.");
      return;
    }

    setLoading(true);
    try {
      await handleGiveReviewAccess(
        email?.toLowerCase(),
        selectedRole,
        setMessage,
      );
      // Clear form on success
      setTimeout(() => {
        setEmail("");
        setSelectedRole("reviewer");
      }, 2000);
    } catch (error) {
      setMessage("Failed to grant access.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="user-header"
      style={{
        paddingTop: deviceType === "iOS" ? "15px" : "auto",
        height: "40px",
      }}
    >
      <div>
        <ApplicationDeadline shorten />
      </div>
      <div className="user-info">
        <p>
          {getNameOrEmail()}{" "}
          {profile?.roles?.includes("reviewer") &&
            profile?.roles?.includes("giveReviewAccess") &&
            " | "}
        </p>
        {profile?.roles?.includes("giveReviewAccess") && (
          <FaGear
            onClick={openModal}
            style={{
              margin: deviceType === "iOS" ? "12px 5px" : "18px 5px",
              cursor: "pointer",
            }}
            size={20}
          />
        )}
      </div>
      {/* user is requesting to give review access */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="give-review-access-modal"
        style={{
          marginTop: "100px",
        }}
      >
        <button
          onClick={closeModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        >
          X
        </button>
        <div className="give-review-access-modal-container">
          <h2>Grant Access</h2>
          <p>
            Enter the email address of the person you want to grant access to.
            Choose their role and submit.
          </p>

          <div className="give-review-access">
            <div className="form-group">
              <label htmlFor="email-input">Email Address</label>
              <input
                id="email-input"
                type="email"
                placeholder="example@email.com"
                className="email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value?.trim())}
              />
            </div>

            <div className="form-group">
              <label htmlFor="role-select">Access Level</label>
              <select
                id="role-select"
                className="role-select"
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
              >
                <option value="reviewer">Reviewer</option>
                <option value="giveReviewAccess">Admin</option>
              </select>
              <p className="role-description">
                {selectedRole === "reviewer"
                  ? "Can review and score applications"
                  : "Can review applications and grant access to others"}
              </p>
            </div>

            <div className="button-group">
              <button
                className="primary-btn submit-btn-modal"
                onClick={giveReviewAccess}
                disabled={loading}
              >
                {loading ? "Granting..." : "Grant Access"}
              </button>
              <button
                className="secondary-btn close-btn-modal"
                onClick={closeModal}
              >
                Cancel
              </button>
            </div>
          </div>

          {message && (
            <div
              className={`message-box ${message.includes("granted") ? "success" : "error"}`}
            >
              {message}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default UserHeader;
